var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Authenticator_(April_2023) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9997 11.9998C23.9997 13.1164 23.0945 14.0215 21.978 14.0215H14.9999L12 7.95581L15.238 2.34758C15.7963 1.38068 17.0326 1.04937 17.9996 1.60757L18 1.60779C18.967 2.16602 19.2983 3.40247 18.7401 4.36946L15.5021 9.97815H21.978C23.0945 9.97815 23.9997 10.8833 23.9997 11.9998Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9995 22.3919L17.9991 22.3921C17.0321 22.9503 15.7958 22.619 15.2375 21.6521L11.9995 16.0439L8.7615 21.6521C8.20325 22.619 6.96688 22.9503 5.99994 22.3921L5.99955 22.3919C5.03255 21.8337 4.70119 20.5972 5.25945 19.6302L8.49742 14.0215L11.9995 13.8911L15.5016 14.0215L18.7396 19.6302C19.2978 20.5972 18.9665 21.8337 17.9995 22.3919Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9995 7.95581L11.0865 10.4347L8.49742 9.97815L5.25945 4.36946C4.70119 3.40248 5.03255 2.16602 5.99955 1.60779L5.99994 1.60757C6.96688 1.04937 8.20325 1.38068 8.76151 2.34758L11.9995 7.95581Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.478 9.97803L9.13019 14.0214H2.02168C0.905138 14.0214 0 13.1163 0 11.9997C0 10.8832 0.905138 9.97803 2.02168 9.97803H11.478Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.5022 14.0218H8.49805L12.0001 7.95605L15.5022 14.0218Z",
    fill: "#185DB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.14f04928a9a43bdb750f7b02f9b39aa0.svg";
export { ForwardRef as ReactComponent };